<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xv"><span class="ht">AFTER</span> <b>EMERSON</b></a></p><a id="page_xv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Fm03.vue?1afcf4aa